/* parser generated by jison 0.4.18 */
/*
  Returns a Parser object of the following structure:

  Parser: {
    yy: {}
  }

  Parser.prototype: {
    yy: {},
    trace: function(),
    symbols_: {associative list: name ==> number},
    terminals_: {associative list: number ==> name},
    productions_: [...],
    performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$),
    table: [...],
    defaultActions: {...},
    parseError: function(str, hash),
    parse: function(input),

    lexer: {
        EOF: 1,
        parseError: function(str, hash),
        setInput: function(input),
        input: function(),
        unput: function(str),
        more: function(),
        less: function(n),
        pastInput: function(),
        upcomingInput: function(),
        showPosition: function(),
        test_match: function(regex_match_array, rule_index),
        next: function(),
        lex: function(),
        begin: function(condition),
        popState: function(),
        _currentRules: function(),
        topState: function(),
        pushState: function(condition),

        options: {
            ranges: boolean           (optional: true ==> token location info will include a .range[] member)
            flex: boolean             (optional: true ==> flex-like lexing behaviour where the rules are tested exhaustively to find the longest match)
            backtrack_lexer: boolean  (optional: true ==> lexer regexes are tested in order and for each matching regex the action code is invoked; the lexer terminates the scan when a token is returned by the action code)
        },

        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START),
        rules: [...],
        conditions: {associative list: name ==> set},
    }
  }


  token location info (@$, _$, etc.): {
    first_line: n,
    last_line: n,
    first_column: n,
    last_column: n,
    range: [start_number, end_number]       (where the numbers are indexes into the input string, regular zero-based)
  }


  the parseError function receives a 'hash' object with these members for lexer and parser errors: {
    text:        (matched text)
    token:       (the produced terminal token, if any)
    line:        (yylineno)
  }
  while parser (grammar) errors will also provide these members, i.e. parser errors deliver a superset of attributes: {
    loc:         (yylloc)
    expected:    (string describing the set of expected tokens)
    recoverable: (boolean: TRUE when the parser has a error recovery rule available for this particular error)
  }
*/
var xmlReport = (function(){
var o=function(k,v,o,l){for(o=o||{},l=k.length;l--;o[k[l]]=v);return o},$V0=[1,6],$V1=[1,8],$V2=[1,4],$V3=[1,16],$V4=[1,27],$V5=[1,35],$V6=[1,36],$V7=[1,26],$V8=[1,25],$V9=[1,29],$Va=[1,30],$Vb=[1,31],$Vc=[1,32],$Vd=[1,33],$Ve=[1,28],$Vf=[1,34],$Vg=[6,8,15],$Vh=[1,48],$Vi=[1,56],$Vj=[1,57],$Vk=[1,47],$Vl=[1,46],$Vm=[1,49],$Vn=[1,50],$Vo=[1,51],$Vp=[1,52],$Vq=[1,53],$Vr=[1,54],$Vs=[1,55],$Vt=[4,6,15,17,18,19,20,21,22,23,24,25,26],$Vu=[1,4,11],$Vv=[5,6,8,15];
var parser = {trace: function trace () { },
yy: {},
symbols_: {"error":2,"INIT":3,"menor":4,"?":5,"id":6,"ATRIBUTO":7,"mayor":8,"INTRO":9,"NODO":10,"EOF":11,"CHECK":12,"LISTAATRIBUTOS":13,"LISTANODOS":14,"/":15,"NODOTEXTO":16,"=":17,"sstring":18,"dstring":19,"lessthan":20,"greaterthan":21,"ampersand":22,"apostrophe":23,"quotmark":24,"number":25,"random":26,"$accept":0,"$end":1},
terminals_: {2:"error",4:"menor",5:"?",6:"id",8:"mayor",11:"EOF",15:"/",17:"=",18:"sstring",19:"dstring",20:"lessthan",21:"greaterthan",22:"ampersand",23:"apostrophe",24:"quotmark",25:"number",26:"random"},
productions_: [0,[3,8],[3,1],[9,3],[9,2],[12,1],[12,0],[10,9],[10,9],[10,5],[10,8],[10,8],[10,4],[14,2],[14,1],[13,2],[13,1],[7,3],[7,3],[16,2],[16,2],[16,2],[16,2],[16,2],[16,2],[16,2],[16,2],[16,2],[16,2],[16,2],[16,2],[16,1],[16,1],[16,1],[16,1],[16,1],[16,1],[16,1],[16,1],[16,1],[16,1],[16,1],[16,1]],
performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate /* action[1] */, $$ /* vstack */, _$ /* lstack */) {
/* this == yyval */

var $0 = $$.length - 1;
switch (yystate) {
case 1:

        txtGramProd.push("INIT := menor ? id ATRIBUTO ATRIBUTO ? mayor INTRO");
        txtGramRegSem.push("INIT.val := INTRO.val");
        contador++;
        raiz.crearNodo("<",contador,[]);
        contador++;
        raiz.crearNodo("?",contador,[]);
        contador++;
        raiz.crearNodo("id",contador,[]);
        contador++;
        raiz.crearNodo("ATRIBUTO",contador,$$[$0-4]);
        contador++;
        raiz.crearNodo("ATRIBUTO",contador,$$[$0-3]);
        contador++;
        raiz.crearNodo("?",contador,[]);
        contador++;
        raiz.crearNodo(">",contador,[]);
        contador++;
        raiz.crearNodo("INTRO",contador,$$[$0]);
        
        contador = 0;
        raizaux = raiz;
        raiz = new NodoCST("INIT",0,[]);
        txtGramProdAux = txtGramProd;
        txtGramProd = [];
        txtGramRegSemAux = txtGramRegSem;
        txtGramRegSem = [];

        return {ReporteGramatical: [txtGramProdAux,txtGramRegSemAux],ReporteCST: raizaux};
    
break;
case 2:

        txtGramProd.push("INIT := INTRO");
        txtGramRegSem.push("INIT.val := INTRO.val");
        contador++;
        raiz.crearNodo("INTRO",contador,$$[$0])
        
        contador = 0;
        raizaux = raiz;
        raiz = new NodoCST("INIT",0,[]);
        txtGramProdAux = txtGramProd;
        txtGramProd = [];
        txtGramRegSemAux = txtGramRegSem;
        txtGramRegSem = [];

        return {ReporteGramatical: [txtGramProdAux,txtGramRegSemAux],ReporteCST: raizaux};
    
break;
case 3:

        txtGramProd.push("INTRO := INTRO NODO EOF");
        txtGramRegSem.push("INTRO.push(NODO.val); INTRO.val = INTRO.val");
        contador++;
        nodoaux = new NodoCST("INTRO",contador,$$[$0-2]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST("NODO",contador,$$[$0-1]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST("EOF",contador,$$[$0]);
        lista.push(nodoaux);
        this.$ = lista;
        lista = [];
    
break;
case 4:

        txtGramProd.push("INTRO := NODO CHECK");
        txtGramRegSem.push("INTRO.val = NODO.val");
        contador++;
        nodoaux = new NodoCST("NODO",contador,$$[$0-1]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST("CHECK",contador,$$[$0]);
        lista.push(nodoaux);
        this.$ = lista;
        lista = [];
    
break;
case 5:

        txtGramProd.push("CHECK := EOF");
        txtGramRegSem.push("CHECK.val := EOF");
        contador++;
        nodoaux = new NodoCST("EOF",contador,[]);
        lista.push(nodoaux);
        this.$ = lista;
        lista = [];
    
break;
case 6:

        txtGramProd.push("CHECK := ε");
        txtGramRegSem.push("CHECK := ε");
        contador++;
        nodoaux = new NodoCST("ε",contador,[]);
        lista.push(nodoaux);
        this.$ = lista;
        lista = [];
    
break;
case 7:

        txtGramProd.push("NODO := menor id LISTAATRIBUTOS mayor LISTANODOS menor / id mayor");
        txtGramRegSem.push("NODO.val = new Entorno(id,[],line, column,LISTAATRIBUTOS.val,LISTANODOS.val)");
        contador++;
        nodoaux = new NodoCST("<",contador,[]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST("id",contador,[]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST("LISTAATRIBUTOS",contador,$$[$0-6]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST(">",contador,[]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST("LISTANODOS",contador,$$[$0-4]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST("<",contador,[]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST("/",contador,[]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST("id",contador,[]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST(">",contador,[]);
        lista.push(nodoaux);
        this.$ = lista;
        lista = [];
    
break;
case 8:

        txtGramProd.push("NODO := menor id LISTAATRIBUTOS mayor NODOTEXTO menor / id mayor");
        txtGramRegSem.push("NODO.val = new Entorno(id,NODOTEXTO.val,line,column,LISTAATRIBUTOS.val,[])");
        contador++;
        nodoaux = new NodoCST("<",contador,[]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST("id",contador,[]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST("LISTAATRIBUTOS",contador,$$[$0-6]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST(">",contador,[]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST("NODOTEXTO",contador,$$[$0-4]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST("<",contador,[]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST("/",contador,[]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST("id",contador,[]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST(">",contador,[]);
        lista.push(nodoaux);
        this.$ = lista;
        lista = [];
    
break;
case 9:

        txtGramProd.push("NODO := menor id LISTAATRIBUTOS / mayor");
        txtGramRegSem.push("NODO.val = new Entorno(id,[],line, column,LISTAATRIBUTOS.val,[])");
        contador++;
        nodoaux = new NodoCST("<",contador,[]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST("id",contador,[]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST("LISTAATRIBUTOS",contador,$$[$0-2]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST("/",contador,[]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST(">",contador,[]);
        lista.push(nodoaux);
        this.$ = lista;
        lista = [];
    
break;
case 10:

        txtGramProd.push("NODO := menor id mayor LISTANODOS menor / id mayor");
        txtGramRegSem.push("NODO.val = new Entorno(id,[],line, column,[],LISTANODOS.val)");
        contador++;
        nodoaux = new NodoCST("<",contador,[]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST("id",contador,[]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST(">",contador,[]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST("LISTANODOS",contador,$$[$0-4]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST("<",contador,[]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST("/",contador,[]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST("id",contador,[]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST(">",contador,[]);
        lista.push(nodoaux);
        this.$ = lista;
        lista = [];
    
break;
case 11:

        txtGramProd.push("NODO := menor id mayor NODOTEXTO menor / id mayor");
        txtGramRegSem.push("NODO.val := new Entorno(id,NODOTEXTO.val,line, column,[],[])");
        contador++;
        nodoaux = new NodoCST("<",contador,[]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST("id",contador,[]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST(">",contador,[]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST("NODOTEXTO",contador,$$[$0-4]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST("<",contador,[]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST("/",contador,[]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST("id",contador,[]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST(">",contador,[]);
        lista.push(nodoaux);
        this.$ = lista;
        lista = [];
    
break;
case 12:

        txtGramProd.push("NODO := menor id / mayor");
        txtGramRegSem.push("NODO.val = new Entorno(id,[],line, column,[],[])");
        contador++;
        nodoaux = new NodoCST("<",contador,[]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST("id",contador,[]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST("/",contador,[]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST(">",contador,[]);
        lista.push(nodoaux);
        this.$ = lista;
        lista = [];
    
break;
case 13:

        txtGramProd.push("LISTANODOS := LISTANODOS NODO");
        txtGramRegSem.push("LISTANODOS.push(NODO.val); LISTANODOS.val := LISTANODOS.val");
        contador++;
        nodoaux = new NodoCST("LISTANODOS",contador,$$[$0-1]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST("NODO",contador,$$[$0]);
        lista.push(nodoaux);
        this.$ = lista;
        lista = [];
    
break;
case 14:

        txtGramProd.push("LISTANODOS := NODO");
        txtGramRegSem.push("LISTANODOS.val = NODO.val");
        contador++;
        nodoaux = new NodoCST("NODO",contador,$$[$0]);
        lista.push(nodoaux);
        this.$ = lista;
        lista = [];
    
break;
case 15:

        txtGramProd.push("LISTAATRIBUTOS := LISTAATRIBUTOS ATRIBUTO");
        txtGramRegSem.push("LISTAATRIBUTOS.push(ATRIBUTO.val);LISTAATRIBUTOS.val = LISTAATRIBUTOS.val;");
        contador++;
        nodoaux = new NodoCST("LISTAATRIBUTOS",contador,$$[$0-1]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST("ATRIBUTO",contador,$$[$0]);
        lista.push(nodoaux);
        this.$ = lista;
        lista = [];
    
break;
case 16:

        txtGramProd.push("LISTAATRIBUTOS := ATRIBUTO");
        txtGramRegSem.push("ATRIBUTO.val = ATRIBUTO.val");
        contador++;
        nodoaux = new NodoCST("ATRIBUTO",contador,$$[$0]);
        lista.push(nodoaux);
        this.$ = lista;
        lista = [];
    
break;
case 17:

        txtGramProd.push("ATRIBUTO := id = sstring");
        txtGramRegSem.push("ATRIBUTO.val := Simbolo(id,sstring,line,column)");
        contador++;
        nodoaux = new NodoCST("id",contador,[]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST("=",contador,[]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST("sstring",contador,[]);
        lista.push(nodoaux);
        this.$ = lista;
        lista = [];
    
break;
case 18:

        txtGramProd.push("ATRIBUTO := id = dstring");
        txtGramRegSem.push("ATRIBUTO.val := new Simbolo(id,dstring,line,column)");
        contador++;
        nodoaux = new NodoCST("id",contador,[]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST("=",contador,[]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST("dstring",contador,[]);
        lista.push(nodoaux);
        this.$ = lista;
        lista = [];
    
break;
case 19:

        txtGramProd.push("NODOTEXTO := NODOTEXTO dstring");
        txtGramRegSem.push("NODOTEXTO.val := NODOTEXTO.val + dstring");
        contador++;
        nodoaux = new NodoCST("NODOTEXTO",contador,$$[$0-1]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST("dstring",contador,[]);
        lista.push(nodoaux);
        this.$ = lista;
        lista = [];
    
break;
case 20:

        txtGramProd.push("NODOTEXTO := NODOTEXTO sstring");
        txtGramRegSem.push("NODOTEXTO.val := NODOTEXTO.val + sstring");
        contador++;
        nodoaux = new NodoCST("NODOTEXTO",contador,$$[$0-1]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST("sstring",contador,[]);
        lista.push(nodoaux);
        this.$ = lista;
        lista = [];
    
break;
case 21:

        txtGramProd.push("NODOTEXTO := NODOTEXTO id");
        txtGramRegSem.push("NODOTEXTO.val := NODOTEXTO.val + id");
        contador++;
        nodoaux = new NodoCST("NODOTEXTO",contador,$$[$0-1]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST("id",contador,[]);
        lista.push(nodoaux);
        this.$ = lista;
        lista = [];
    
break;
case 22:

        txtGramProd.push("NODOTEXTO := NODOTEXTO lessthan");
        txtGramRegSem.push("NODOTEXTO.val := NODOTEXTO.val + lessthan");
        contador++;
        nodoaux = new NodoCST("NODOTEXTO",contador,$$[$0-1]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST("lessthan",contador,[]);
        lista.push(nodoaux);
        this.$ = lista;
        lista = [];
    
break;
case 23:

        txtGramProd.push("NODOTEXTO := NODOTEXTO greaterthan");
        txtGramRegSem.push("NODOTEXTO.val := NODOTEXTO.val + greaterthan");
        contador++;
        nodoaux = new NodoCST("NODOTEXTO",contador,$$[$0-1]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST("greaterthan",contador,[]);
        lista.push(nodoaux);
        this.$ = lista;
        lista = [];
    
break;
case 24:

        txtGramProd.push("NODOTEXTO := NODOTEXTO ampersand");
        txtGramRegSem.push("NODOTEXTO.val := NODOTEXTO.val + ampersand");
        contador++;
        nodoaux = new NodoCST("NODOTEXTO",contador,$$[$0-1]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST("ampersand",contador,[]);
        lista.push(nodoaux);
        this.$ = lista;
        lista = [];
    
break;
case 25:

        txtGramProd.push("NODOTEXTO := NODOTEXTO apostrophe");
        txtGramRegSem.push("NODOTEXTO.val := NODOTEXTO.val + apostrophe");
        contador++;
        nodoaux = new NodoCST("NODOTEXTO",contador,$$[$0-1]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST("apostrophe",contador,[]);
        lista.push(nodoaux);
        this.$ = lista;
        lista = [];
    
break;
case 26:

        txtGramProd.push("NODOTEXTO := NODOTEXTO quotmark");
        txtGramRegSem.push("NODOTEXTO.val := NODOTEXTO.val + quotmark");
        contador++;
        nodoaux = new NodoCST("NODOTEXTO",contador,$$[$0-1]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST("quotmark",contador,[]);
        lista.push(nodoaux);
        this.$ = lista;
        lista = [];
    
break;
case 27:

        txtGramProd.push("NODOTEXTO := NODOTEXTO number");
        txtGramRegSem.push("NODOTEXTO.val := NODOTEXTO.val + number");
        contador++;
        nodoaux = new NodoCST("NODOTEXTO",contador,$$[$0-1]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST("number",contador,[]);
        lista.push(nodoaux);
        this.$ = lista;
        lista = [];
    
break;
case 28:

        txtGramProd.push("NODOTEXTO := NODOTEXTO random");
        txtGramRegSem.push("NODOTEXTO.val := NODOTEXTO.val + random");
        contador++;
        nodoaux = new NodoCST("NODOTEXTO",contador,$$[$0-1]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST("random",contador,[]);
        lista.push(nodoaux);
        this.$ = lista;
        lista = [];
    
break;
case 29:

        txtGramProd.push("NODOTEXTO := NODOTEXTO /");
        txtGramRegSem.push("NODOTEXTO.val := NODOTEXTO.val + /");
        contador++;
        nodoaux = new NodoCST("NODOTEXTO",contador,$$[$0-1]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST("/",contador,[]);
        lista.push(nodoaux);
        this.$ = lista;
        lista = [];
    
break;
case 30:

        txtGramProd.push("NODOTEXTO := NODOTEXTO =");
        txtGramRegSem.push("NODOTEXTO.val := NODOTEXTO.val + =");
        contador++;
        nodoaux = new NodoCST("NODOTEXTO",contador,$$[$0-1]);
        lista.push(nodoaux);
        contador++;
        nodoaux = new NodoCST("=",[]);
        lista.push(nodoaux);
        this.$ = lista;
        lista = [];
    
break;
case 31:

        txtGramProd.push("NODOTEXTO := dstring");
        txtGramRegSem.push("NODOTEXTO.val := dstring");
        contador++;
        nodoaux = new NodoCST("dstring",contador,[]);
        lista.push(nodoaux);
        this.$ = lista;
        lista = [];
    
break;
case 32:

        txtGramProd.push("NODOTEXTO := sstring");
        txtGramRegSem.push("NODOTEXTO.val := sstring");
        contador++;
        nodoaux = new NodoCST("sstring",contador,[]);
        lista.push(nodoaux);
        this.$ = lista;
        lista = [];
    
break;
case 33:

        txtGramProd.push("NODOTEXTO := id");
        txtGramRegSem.push("NODOTEXTO.val := id");
        contador++;
        nodoaux = new NodoCST("id",contador,[]);
        lista.push(nodoaux);
        this.$ = lista;
        lista = [];
    
break;
case 34:

        txtGramProd.push("NODOTEXTO := number");
        txtGramRegSem.push("NODOTEXTO.val := number");
        contador++;
        nodoaux = new NodoCST("number",contador,[]);
        lista.push(nodoaux);
        this.$ = lista;
        lista = [];
    
break;
case 35:

        txtGramProd.push("NODOTEXTO := lessthan");
        txtGramRegSem.push("NODOTEXTO.val := lessthan");
        contador++;
        nodoaux = new NodoCST("lessthan",contador,[]);
        lista.push(nodoaux);
        this.$ = lista;
        lista = [];
    
break;
case 36:

        txtGramProd.push("NODOTEXTO := greaterthan");
        txtGramRegSem.push("NODOTEXTO.val := greaterthan");
        contador++;
        nodoaux = new NodoCST("greaterthan",contador,[]);
        lista.push(nodoaux);
        this.$ = lista;
        lista = [];
    
break;
case 37:

        txtGramProd.push("NODOTEXTO := ampersand");
        txtGramRegSem.push("NODOTEXTO.val := ampersand");
        contador++;
        nodoaux = new NodoCST("ampersand",contador,[]);
        lista.push(nodoaux);
        this.$ = lista;
        lista = [];
    
break;
case 38:

        txtGramProd.push("NODOTEXTO := apostrophe");
        txtGramRegSem.push("NODOTEXTO.val := apostrophe");
        contador++;
        nodoaux = new NodoCST("apostrophe",contador,[]);
        lista.push(nodoaux);
        this.$ = lista;
        lista = [];
    
break;
case 39:

        txtGramProd.push("NODOTEXTO := quotmark");
        txtGramRegSem.push("NODOTEXTO.val := quotmark");
        contador++;
        nodoaux = new NodoCST("quotmark",contador,[]);
        lista.push(nodoaux);
        this.$ = lista;
        lista = [];
    
break;
case 40:

        txtGramProd.push("NODOTEXTO := random");
        txtGramRegSem.push("NODOTEXTO.val := random");
        contador++;
        nodoaux = new NodoCST("random",contador,[]);
        lista.push(nodoaux);
        this.$ = lista;
        lista = [];
    
break;
case 41:

        txtGramProd.push("NODOTEXTO := /");
        txtGramRegSem.push("NODOTEXTO.val := /");
        contador++;
        nodoaux = new NodoCST("/",contador,[]);
        lista.push(nodoaux);
        this.$ = lista;
        lista = [];
    
break;
case 42:

        txtGramProd.push("NODOTEXTO := =");
        txtGramRegSem.push("NODOTEXTO.val := =");
        contador++;
        nodoaux = new NodoCST("=",contador,[]);
        lista.push(nodoaux);
        this.$ = lista;
        lista = [];
    
break;
}
},
table: [{3:1,4:[1,2],9:3,10:4},{1:[3]},{5:[1,5],6:$V0},{1:[2,2],4:$V1,10:7},o($V2,[2,6],{12:9,11:[1,10]}),{6:[1,11]},{6:$V3,7:15,8:[1,13],13:12,15:[1,14]},{11:[1,17]},{6:$V0},o($V2,[2,4]),o($V2,[2,5]),{6:$V3,7:18},{6:$V3,7:21,8:[1,19],15:[1,20]},{4:$V1,6:$V4,10:24,14:22,15:$V5,16:23,17:$V6,18:$V7,19:$V8,20:$V9,21:$Va,22:$Vb,23:$Vc,24:$Vd,25:$Ve,26:$Vf},{8:[1,37]},o($Vg,[2,16]),{17:[1,38]},o($V2,[2,3]),{6:$V3,7:39},{4:$V1,6:$V4,10:24,14:40,15:$V5,16:41,17:$V6,18:$V7,19:$V8,20:$V9,21:$Va,22:$Vb,23:$Vc,24:$Vd,25:$Ve,26:$Vf},{8:[1,42]},o($Vg,[2,15]),{4:[1,43],10:44},{4:[1,45],6:$Vh,15:$Vi,17:$Vj,18:$Vk,19:$Vl,20:$Vm,21:$Vn,22:$Vo,23:$Vp,24:$Vq,25:$Vr,26:$Vs},{4:[2,14]},o($Vt,[2,31]),o($Vt,[2,32]),o($Vt,[2,33]),o($Vt,[2,34]),o($Vt,[2,35]),o($Vt,[2,36]),o($Vt,[2,37]),o($Vt,[2,38]),o($Vt,[2,39]),o($Vt,[2,40]),o($Vt,[2,41]),o($Vt,[2,42]),o($Vu,[2,12]),{18:[1,58],19:[1,59]},{5:[1,60]},{4:[1,61],10:44},{4:[1,62],6:$Vh,15:$Vi,17:$Vj,18:$Vk,19:$Vl,20:$Vm,21:$Vn,22:$Vo,23:$Vp,24:$Vq,25:$Vr,26:$Vs},o($Vu,[2,9]),{6:$V0,15:[1,63]},{4:[2,13]},{15:[1,64]},o($Vt,[2,19]),o($Vt,[2,20]),o($Vt,[2,21]),o($Vt,[2,22]),o($Vt,[2,23]),o($Vt,[2,24]),o($Vt,[2,25]),o($Vt,[2,26]),o($Vt,[2,27]),o($Vt,[2,28]),o($Vt,[2,29]),o($Vt,[2,30]),o($Vv,[2,17]),o($Vv,[2,18]),{8:[1,65]},{6:$V0,15:[1,66]},{15:[1,67]},{6:[1,68]},{6:[1,69]},{4:$V1,9:70,10:4},{6:[1,71]},{6:[1,72]},{8:[1,73]},{8:[1,74]},{1:[2,1],4:$V1,10:7},{8:[1,75]},{8:[1,76]},o($Vu,[2,10]),o($Vu,[2,11]),o($Vu,[2,7]),o($Vu,[2,8])],
defaultActions: {24:[2,14],44:[2,13]},
parseError: function parseError (str, hash) {
    if (hash.recoverable) {
        this.trace(str);
    } else {
        var error = new Error(str);
        error.hash = hash;
        throw error;
    }
},
parse: function parse(input) {
    var self = this, stack = [0], tstack = [], vstack = [null], lstack = [], table = this.table, yytext = '', yylineno = 0, yyleng = 0, recovering = 0, TERROR = 2, EOF = 1;
    var args = lstack.slice.call(arguments, 1);
    var lexer = Object.create(this.lexer);
    var sharedState = { yy: {} };
    for (var k in this.yy) {
        if (Object.prototype.hasOwnProperty.call(this.yy, k)) {
            sharedState.yy[k] = this.yy[k];
        }
    }
    lexer.setInput(input, sharedState.yy);
    sharedState.yy.lexer = lexer;
    sharedState.yy.parser = this;
    if (typeof lexer.yylloc == 'undefined') {
        lexer.yylloc = {};
    }
    var yyloc = lexer.yylloc;
    lstack.push(yyloc);
    var ranges = lexer.options && lexer.options.ranges;
    if (typeof sharedState.yy.parseError === 'function') {
        this.parseError = sharedState.yy.parseError;
    } else {
        this.parseError = Object.getPrototypeOf(this).parseError;
    }
    function popStack(n) {
        stack.length = stack.length - 2 * n;
        vstack.length = vstack.length - n;
        lstack.length = lstack.length - n;
    }
    _token_stack:
        var lex = function () {
            var token;
            token = lexer.lex() || EOF;
            if (typeof token !== 'number') {
                token = self.symbols_[token] || token;
            }
            return token;
        };
    var symbol, preErrorSymbol, state, action, a, r, yyval = {}, p, len, newState, expected;
    while (true) {
        state = stack[stack.length - 1];
        if (this.defaultActions[state]) {
            action = this.defaultActions[state];
        } else {
            if (symbol === null || typeof symbol == 'undefined') {
                symbol = lex();
            }
            action = table[state] && table[state][symbol];
        }
                    if (typeof action === 'undefined' || !action.length || !action[0]) {
                var errStr = '';
                expected = [];
                for (p in table[state]) {
                    if (this.terminals_[p] && p > TERROR) {
                        expected.push('\'' + this.terminals_[p] + '\'');
                    }
                }
                if (lexer.showPosition) {
                    errStr = 'Parse error on line ' + (yylineno + 1) + ':\n' + lexer.showPosition() + '\nExpecting ' + expected.join(', ') + ', got \'' + (this.terminals_[symbol] || symbol) + '\'';
                } else {
                    errStr = 'Parse error on line ' + (yylineno + 1) + ': Unexpected ' + (symbol == EOF ? 'end of input' : '\'' + (this.terminals_[symbol] || symbol) + '\'');
                }
                this.parseError(errStr, {
                    text: lexer.match,
                    token: this.terminals_[symbol] || symbol,
                    line: lexer.yylineno,
                    loc: yyloc,
                    expected: expected
                });
            }
        if (action[0] instanceof Array && action.length > 1) {
            throw new Error('Parse Error: multiple actions possible at state: ' + state + ', token: ' + symbol);
        }
        switch (action[0]) {
        case 1:
            stack.push(symbol);
            vstack.push(lexer.yytext);
            lstack.push(lexer.yylloc);
            stack.push(action[1]);
            symbol = null;
            if (!preErrorSymbol) {
                yyleng = lexer.yyleng;
                yytext = lexer.yytext;
                yylineno = lexer.yylineno;
                yyloc = lexer.yylloc;
                if (recovering > 0) {
                    recovering--;
                }
            } else {
                symbol = preErrorSymbol;
                preErrorSymbol = null;
            }
            break;
        case 2:
            len = this.productions_[action[1]][1];
            yyval.$ = vstack[vstack.length - len];
            yyval._$ = {
                first_line: lstack[lstack.length - (len || 1)].first_line,
                last_line: lstack[lstack.length - 1].last_line,
                first_column: lstack[lstack.length - (len || 1)].first_column,
                last_column: lstack[lstack.length - 1].last_column
            };
            if (ranges) {
                yyval._$.range = [
                    lstack[lstack.length - (len || 1)].range[0],
                    lstack[lstack.length - 1].range[1]
                ];
            }
            r = this.performAction.apply(yyval, [
                yytext,
                yyleng,
                yylineno,
                sharedState.yy,
                action[1],
                vstack,
                lstack
            ].concat(args));
            if (typeof r !== 'undefined') {
                return r;
            }
            if (len) {
                stack = stack.slice(0, -1 * len * 2);
                vstack = vstack.slice(0, -1 * len);
                lstack = lstack.slice(0, -1 * len);
            }
            stack.push(this.productions_[action[1]][0]);
            vstack.push(yyval.$);
            lstack.push(yyval._$);
            newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
            stack.push(newState);
            break;
        case 3:
            return true;
        }
    }
    return true;
}};

    const {NodoCST} = require("./NodoCST");
    var raiz = new NodoCST("INIT",0,[]);
    var raizaux;
    var nodoaux;
    var lista = [];
    var contador = 0;
    var texto = "";
    var txtGramProd = [];
    var txtGramProdAux = [];
    var txtGramRegSem = [];
    var txtGramRegSemAux = [];
/* generated by jison-lex 0.3.4 */
var lexer = (function(){
var lexer = ({

EOF:1,

parseError:function parseError(str, hash) {
        if (this.yy.parser) {
            this.yy.parser.parseError(str, hash);
        } else {
            throw new Error(str);
        }
    },

// resets the lexer, sets new input
setInput:function (input, yy) {
        this.yy = yy || this.yy || {};
        this._input = input;
        this._more = this._backtrack = this.done = false;
        this.yylineno = this.yyleng = 0;
        this.yytext = this.matched = this.match = '';
        this.conditionStack = ['INITIAL'];
        this.yylloc = {
            first_line: 1,
            first_column: 0,
            last_line: 1,
            last_column: 0
        };
        if (this.options.ranges) {
            this.yylloc.range = [0,0];
        }
        this.offset = 0;
        return this;
    },

// consumes and returns one char from the input
input:function () {
        var ch = this._input[0];
        this.yytext += ch;
        this.yyleng++;
        this.offset++;
        this.match += ch;
        this.matched += ch;
        var lines = ch.match(/(?:\r\n?|\n).*/g);
        if (lines) {
            this.yylineno++;
            this.yylloc.last_line++;
        } else {
            this.yylloc.last_column++;
        }
        if (this.options.ranges) {
            this.yylloc.range[1]++;
        }

        this._input = this._input.slice(1);
        return ch;
    },

// unshifts one char (or a string) into the input
unput:function (ch) {
        var len = ch.length;
        var lines = ch.split(/(?:\r\n?|\n)/g);

        this._input = ch + this._input;
        this.yytext = this.yytext.substr(0, this.yytext.length - len);
        //this.yyleng -= len;
        this.offset -= len;
        var oldLines = this.match.split(/(?:\r\n?|\n)/g);
        this.match = this.match.substr(0, this.match.length - 1);
        this.matched = this.matched.substr(0, this.matched.length - 1);

        if (lines.length - 1) {
            this.yylineno -= lines.length - 1;
        }
        var r = this.yylloc.range;

        this.yylloc = {
            first_line: this.yylloc.first_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.first_column,
            last_column: lines ?
                (lines.length === oldLines.length ? this.yylloc.first_column : 0)
                 + oldLines[oldLines.length - lines.length].length - lines[0].length :
              this.yylloc.first_column - len
        };

        if (this.options.ranges) {
            this.yylloc.range = [r[0], r[0] + this.yyleng - len];
        }
        this.yyleng = this.yytext.length;
        return this;
    },

// When called from action, caches matched text and appends it on next action
more:function () {
        this._more = true;
        return this;
    },

// When called from action, signals the lexer that this rule fails to match the input, so the next matching rule (regex) should be tested instead.
reject:function () {
        if (this.options.backtrack_lexer) {
            this._backtrack = true;
        } else {
            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n' + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
            });

        }
        return this;
    },

// retain first n characters of the match
less:function (n) {
        this.unput(this.match.slice(n));
    },

// displays already matched input, i.e. for error messages
pastInput:function () {
        var past = this.matched.substr(0, this.matched.length - this.match.length);
        return (past.length > 20 ? '...':'') + past.substr(-20).replace(/\n/g, "");
    },

// displays upcoming input, i.e. for error messages
upcomingInput:function () {
        var next = this.match;
        if (next.length < 20) {
            next += this._input.substr(0, 20-next.length);
        }
        return (next.substr(0,20) + (next.length > 20 ? '...' : '')).replace(/\n/g, "");
    },

// displays the character position where the lexing error occurred, i.e. for error messages
showPosition:function () {
        var pre = this.pastInput();
        var c = new Array(pre.length + 1).join("-");
        return pre + this.upcomingInput() + "\n" + c + "^";
    },

// test the lexed token: return FALSE when not a match, otherwise return token
test_match:function(match, indexed_rule) {
        var token,
            lines,
            backup;

        if (this.options.backtrack_lexer) {
            // save context
            backup = {
                yylineno: this.yylineno,
                yylloc: {
                    first_line: this.yylloc.first_line,
                    last_line: this.last_line,
                    first_column: this.yylloc.first_column,
                    last_column: this.yylloc.last_column
                },
                yytext: this.yytext,
                match: this.match,
                matches: this.matches,
                matched: this.matched,
                yyleng: this.yyleng,
                offset: this.offset,
                _more: this._more,
                _input: this._input,
                yy: this.yy,
                conditionStack: this.conditionStack.slice(0),
                done: this.done
            };
            if (this.options.ranges) {
                backup.yylloc.range = this.yylloc.range.slice(0);
            }
        }

        lines = match[0].match(/(?:\r\n?|\n).*/g);
        if (lines) {
            this.yylineno += lines.length;
        }
        this.yylloc = {
            first_line: this.yylloc.last_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.last_column,
            last_column: lines ?
                         lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length :
                         this.yylloc.last_column + match[0].length
        };
        this.yytext += match[0];
        this.match += match[0];
        this.matches = match;
        this.yyleng = this.yytext.length;
        if (this.options.ranges) {
            this.yylloc.range = [this.offset, this.offset += this.yyleng];
        }
        this._more = false;
        this._backtrack = false;
        this._input = this._input.slice(match[0].length);
        this.matched += match[0];
        token = this.performAction.call(this, this.yy, this, indexed_rule, this.conditionStack[this.conditionStack.length - 1]);
        if (this.done && this._input) {
            this.done = false;
        }
        if (token) {
            return token;
        } else if (this._backtrack) {
            // recover context
            for (var k in backup) {
                this[k] = backup[k];
            }
            return false; // rule action called reject() implying the next rule should be tested instead.
        }
        return false;
    },

// return next match in input
next:function () {
        if (this.done) {
            return this.EOF;
        }
        if (!this._input) {
            this.done = true;
        }

        var token,
            match,
            tempMatch,
            index;
        if (!this._more) {
            this.yytext = '';
            this.match = '';
        }
        var rules = this._currentRules();
        for (var i = 0; i < rules.length; i++) {
            tempMatch = this._input.match(this.rules[rules[i]]);
            if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                match = tempMatch;
                index = i;
                if (this.options.backtrack_lexer) {
                    token = this.test_match(tempMatch, rules[i]);
                    if (token !== false) {
                        return token;
                    } else if (this._backtrack) {
                        match = false;
                        continue; // rule action called reject() implying a rule MISmatch.
                    } else {
                        // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                        return false;
                    }
                } else if (!this.options.flex) {
                    break;
                }
            }
        }
        if (match) {
            token = this.test_match(match, rules[index]);
            if (token !== false) {
                return token;
            }
            // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
            return false;
        }
        if (this._input === "") {
            return this.EOF;
        } else {
            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. Unrecognized text.\n' + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
            });
        }
    },

// return next match that has a token
lex:function lex () {
        var r = this.next();
        if (r) {
            return r;
        } else {
            return this.lex();
        }
    },

// activates a new lexer condition state (pushes the new lexer condition state onto the condition stack)
begin:function begin (condition) {
        this.conditionStack.push(condition);
    },

// pop the previously active lexer condition state off the condition stack
popState:function popState () {
        var n = this.conditionStack.length - 1;
        if (n > 0) {
            return this.conditionStack.pop();
        } else {
            return this.conditionStack[0];
        }
    },

// produce the lexer rule set which is active for the currently active lexer condition state
_currentRules:function _currentRules () {
        if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) {
            return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
        } else {
            return this.conditions["INITIAL"].rules;
        }
    },

// return the currently active lexer condition state; when an index argument is provided it produces the N-th previous condition state, if available
topState:function topState (n) {
        n = this.conditionStack.length - 1 - Math.abs(n || 0);
        if (n >= 0) {
            return this.conditionStack[n];
        } else {
            return "INITIAL";
        }
    },

// alias for begin(condition)
pushState:function pushState (condition) {
        this.begin(condition);
    },

// return the number of states currently on the stack
stateStackSize:function stateStackSize() {
        return this.conditionStack.length;
    },
options: {"case-insensitive":true},
performAction: function anonymous(yy,yy_,$avoiding_name_collisions,YY_START) {
var YYSTATE=YY_START;
switch($avoiding_name_collisions) {
case 0:/* skip whitespace */
break;
case 1:/*skip comments*/
break;
case 2:return 4;
break;
case 3:return 8;
break;
case 4:return 15;
break;
case 5:return 17;
break;
case 6:return 5;
break;
case 7:return 19;
break;
case 8:return 18;
break;
case 9:return 6;
break;
case 10:return 25;
break;
case 11:return 20;
break;
case 12:return 21;
break;
case 13:return 22;
break;
case 14:return 23;
break;
case 15:return 24;
break;
case 16:return 26;
break;
case 17:return 11;
break;
case 18:
                                        console.log('Este es un error léxico: ' + yy_.yytext + ', en la linea: ' + yy_.yylloc.first_line + ', en la columna: ' + yy_.yylloc.first_column);
                                    
break;
}
},
rules: [/^(?:\s+)/i,/^(?:[<][!][-][-][^-<]*[-][-][>])/i,/^(?:<)/i,/^(?:>)/i,/^(?:\/)/i,/^(?:=)/i,/^(?:\?)/i,/^(?:("([^\"\\])*"))/i,/^(?:('([^\'\\])*'))/i,/^(?:([a-zA-Z_]|á|é|í|ó|ú|Á|É|Í|Ó|Ú)(-|[a-zA-Z0-9_ñÑ]|á|é|í|ó|ú|Á|É|Í|Ó|Ú)*)/i,/^(?:(([0-9]+\.[0-9]+)|(\.[0-9]+)|([0-9]+)))/i,/^(?:&lt;)/i,/^(?:&gt;)/i,/^(?:&amp;)/i,/^(?:&apos;)/i,/^(?:&quot;)/i,/^(?:[^<> ]+)/i,/^(?:$)/i,/^(?:.)/i],
conditions: {"INITIAL":{"rules":[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18],"inclusive":true}}
});
return lexer;
})();
parser.lexer = lexer;
function Parser () {
  this.yy = {};
}
Parser.prototype = parser;parser.Parser = Parser;
return new Parser;
})();


if (typeof require !== 'undefined' && typeof exports !== 'undefined') {
exports.parser = xmlReport;
exports.Parser = xmlReport.Parser;
exports.parse = function () { return xmlReport.parse.apply(xmlReport, arguments); };
exports.main = function commonjsMain (args) {
    if (!args[1]) {
        console.log('Usage: '+args[0]+' FILE');
        process.exit(1);
    }
    var source = require('fs').readFileSync(require('path').normalize(args[1]), "utf8");
    return exports.parser.parse(source);
};
if (typeof module !== 'undefined' && require.main === module) {
  exports.main(process.argv.slice(1));
}
}